// extracted by mini-css-extract-plugin
export default {"upload-content":"FileUpload_upload-content__2r04B","upload-label":"FileUpload_upload-label__bjvoZ"};